// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import { installGuards } from './guards.js';

import authRoutes from './modules/auth.js';
import adminCreationRoutes from './modules/adminCreation.js';
import crmRoutes from './modules/crm.js';
import managementRoutes from './modules/management.js';
import academyRoutes from './modules/academy.js';

const routes = [
    ...authRoutes,
    ...adminCreationRoutes,
    ...managementRoutes,
    ...crmRoutes,
    ...academyRoutes,
    { path: '/', redirect: '/gestion' },
    { path: '/:notFound(.*)', redirect: '/gestion' },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

installGuards(router);

export default router;
